module.exports = fox._r("images/processing_icon_small.gif", __webpack_public_path__ + "_/_/_/common/frame/images/processing_icon_small.gif");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/processing_icon_small.gif
// module id = 125
// module chunks = 2